import { render, staticRenderFns } from "./banner-add.vue?vue&type=template&id=6397a12a&scoped=true&"
import script from "./banner-add.vue?vue&type=script&lang=js&"
export * from "./banner-add.vue?vue&type=script&lang=js&"
import style0 from "./banner-add.vue?vue&type=style&index=0&id=6397a12a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6397a12a",
  null
  
)

export default component.exports